export type PaidSignalAmount = {
    sats: number
    usd: number | null
}

export type PaidSignalDefaults = {
    upvalueSats: number
    upvalueUsd: number | null
    seedSats: number
    seedUsd: number | null
}

export function paidSignalDefault(isSeed: boolean, defaults: PaidSignalDefaults): PaidSignalAmount {
    return isSeed
        ? { sats: defaults.seedSats, usd: defaults.seedUsd }
        : { sats: defaults.upvalueSats, usd: defaults.upvalueUsd }
}

export function paidSignalDefaultOptions(isSeed: boolean, amount: PaidSignalAmount) {
    return isSeed
        ? { seedSats: amount.sats, seedUsd: amount.usd }
        : { upvalueSats: amount.sats, upvalueUsd: amount.usd }
}

export function paidSignalOpeningSats({
    requestedSeed,
    freeReactionAvailable,
    upvaluesEnabled,
    nextPressIsFree,
    defaultSats,
}: {
    requestedSeed: boolean
    freeReactionAvailable: boolean
    upvaluesEnabled: boolean
    nextPressIsFree: boolean
    defaultSats: number
}) {
    const armFree = !requestedSeed && freeReactionAvailable && (!upvaluesEnabled || nextPressIsFree)

    return armFree ? 0 : defaultSats
}

export function seedMinimumDefaultOptions(seedSats: number | null, minimumSeedSats: number) {
    return {
        seedSats: Math.max(seedSats || 0, minimumSeedSats),
        seedUsd: null,
    }
}
